import pubNubTimetokenToTimestamp from "./pubnub-timetoken-to-timestamp";

const pubNubTimetokenToDate = (pubNubTimeToken: string) =>
  new Date(pubNubTimetokenToTimestamp(pubNubTimeToken));

export default pubNubTimetokenToDate;
